module.exports = __webpack_public_path__ + "static/pingusenglish.f971c750.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/clients/images/pingusenglish.png
// module id = ./src/app/data/clients/images/pingusenglish.png
// module chunks = 1 2 3